export const nowData = {
  lastUpdated: "2026",
  location: "India",
  headline: "What I am actively building, studying, drafting, and reading today.",
  subheadline: "A live snapshot of current projects, structured learning, and research areas.",
  items: [
    {
      id: "building",
      category: "Building",
      code: "01",
      status: "In Progress / Stealth",
      title: "Independent Software & Systems",
      description:
        "Developing lightweight, deterministic developer utilities and minimal static tools. Prototyping product ideas focused on simplicity, zero-backend durability, and fast local-first workflows.",
      route: "/work",
      actionLabel: "Explore Work"
    },
    {
      id: "writing",
      category: "Writing",
      code: "02",
      status: "In Progress / Drafting",
      title: "Biology through Curiosity : Questions that became Knowledge",
      description:
        "Actively drafting foundational chapters for 'Biology through Curiosity : Questions that became Knowledge', exploring how curious questions transformed into modern biological knowledge.",
      route: "/writing/book",
      actionLabel: "Book Overview"
    },
    {
      id: "studying",
      category: "Studying",
      code: "03",
      status: "Active Preparation",
      title: "Structured Learning (UPSC / SSC Foundations)",
      description:
        "Engaged in systematic daily study across Indian and world history, constitutional governance, political economy, and public administration, while maintaining algorithmic problem-solving sharpness on Codeforces.",
      route: "/journey",
      actionLabel: "View Journey"
    },
    {
      id: "reading",
      category: "Reading",
      code: "04",
      status: "Active Library",
      title: "History, Classics & Literature",
      description:
        "Actively reading classical literature, ancient statecraft treatises (Kautilya's Arthashastra), and civilizational histories to understand grand historical patterns and strategic thinking.",
      route: "/reading/bookshelf",
      actionLabel: "Digital Bookshelf"
    },
    {
      id: "exploring",
      category: "Exploring",
      code: "05",
      status: "Ongoing Inquiry",
      title: "Intersection of Computing & Historical Thought",
      description:
        "Investigating how computational rigor and historical perspective inform one another—from Unix architecture principles to macro-economic cycles and knowledge synthesis.",
      route: "/reading/history",
      actionLabel: "History & Ideas"
    }
  ]
};
